import React, { useState } from "react"
import { toast } from "react-toastify"
import {
    deleteManagerBot,
    extendManagerBot,
    reconnectManagerBot,
    connectManagerBot,
    disconnectManagerBot,
    activateManagerBot,
    suspendManagerBot,
} from "../../services/managerBotApis"
import EditManagerBotModal from "./EditManagerBotModal"
import MyModal from "../MyModal"
import actionHelper from "../../lib/actionHelper"

const ManagerBotMoreModal = ({ user, bot }) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }
    return (
        <>
            <button onClick={toggleModal}>
                <img className="w-5 h-5" src="assets/icons/gear-complex.svg" />
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="800px" height="500px">
                <div className="grid grid-cols-3">
                    <div className="col-span-2 mt-5 mr-5 ml-5   ">
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تمپلیت</a>
                            <a className="float-left text-blue-400">{bot.template_name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>نام</a>
                            <a className="float-left text-blue-400">{bot.conn.botName}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>سرور</a>
                            <a className="float-left text-blue-400">{bot.conn.host}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>کوئری پورت</a>
                            <a className="float-left text-blue-400">{bot.conn.queryPort}</a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>سرور پورت</a>
                            <a className="float-left text-blue-400">{bot.conn.serverPort}</a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>مالک</a>
                            <a className="float-left text-blue-400">{bot.author}</a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ ساخت</a>
                            <a className="float-left text-blue-400">{bot.crtString}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ انقضا</a>
                            <a className="float-left text-blue-400">
                                {bot.expString ? (
                                    bot.expires < 0 ? (
                                        <span class="text-sm font-medium text-red-500">{bot.expString}</span>
                                    ) : (
                                        <span class="text-sm font-medium text-green-500">{bot.expString}</span>
                                    )
                                ) : (
                                    <span class="text-sm font-medium">دائمی</span>
                                )}
                            </a>
                        </li>
                    </div>
                    <div className="col-span-1 flex flex-col ">
                        <EditManagerBotModal bot={bot} />

                        <button
                            onClick={() => {
                                toast.promise(extendManagerBot(bot.id), {
                                    pending: "در حال تمدید بات",
                                    success: "تمدید شد",
                                })
                            }}
                            style={{ backgroundColor: "#22C55E" }}
                            className="flex justify-center gap-2 border bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            <p>تمدید</p>
                        </button>
                        <button
                            onClick={() => {
                                if (bot.state == "suspended") {
                                    toast.error("بات غیرفعال میباشد")
                                    return
                                }
                                toast.promise(connectManagerBot(bot.id), {
                                    pending: "در حال کانکت",
                                    success: "کانکت شد",
                                })
                            }}
                            className="flex justify-center gap-2 border bg-green-500 text-white rounded-3xl px-3 py-1 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/play.svg" width="20px" height="20px" />
                            کانکت
                        </button>
                        <button
                            onClick={() => {
                                toast.promise(disconnectManagerBot(bot.id), {
                                    pending: "در حال دیسکانت",
                                    success: "دیسکانکت شد",
                                    error: "Error",
                                })
                            }}
                            style={{ backgroundColor: "#DC2626" }}
                            className="flex justify-center gap-2 border  text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/power-off.svg" width="20px" height="20px" />
                            دیسکانکت
                        </button>

                        <button
                            onClick={() => {
                                if (bot.state == "suspended") {
                                    toast.error("بات غیرفعال میباشد")
                                    return
                                }

                                toast.promise(reconnectManagerBot(bot.id), {
                                    pending: "در حال ریکانکت",
                                    success: "ریکانکت شد",
                                    error: "Error",
                                })
                            }}
                            style={{ backgroundColor: "#6366F1" }}
                            className="flex justify-center gap-2 border text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-indigo-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            ریکانکت
                        </button>
                        {bot.state == "suspended" ? (
                            <button
                                onClick={() => {
                                    toast.promise(activateManagerBot(bot.id), {
                                        pending: "در حال فعال کردن بات",
                                        success: "فعال شد",
                                        error: "Error",
                                    })
                                }}
                                className="flex justify-center border  bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                </svg>
                                فعال کردن
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    toast.promise(suspendManagerBot(bot.id), {
                                        pending: "در حال غیرفعال کردن بات",
                                        success: "غیرفعال شد",
                                        error: "Error",
                                    })
                                }}
                                style={{ backgroundColor: "#F59E0B" }}
                                className="flex justify-center border text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                </svg>
                                غیرفعال کردن
                            </button>
                        )}
                        <button
                            onClick={() => {
                                toast.promise(deleteManagerBot(bot.id), {
                                    pending: "در حال حذف کردن بات",
                                    success: "حذف شد",
                                })
                            }}
                            style={{ backgroundColor: "#EF4444" }}
                            className="flex justify-center gap-2 border  text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/trash-can.svg" width="20px" height="20px" />
                            حذف
                        </button>
                    </div>
                </div>
            </MyModal>
        </>
    )
}

export default ManagerBotMoreModal
